import type React from "react";
// import { useRef } from "react";
import { useScroll, useTransform } from "motion/react";
import { motion } from "motion/react";
import type { ImpactData } from "../../utils/mockProjects";
import stringToParagraphs from "../../utils/splitPara";

interface ImpactProps {
  impact: ImpactData;
  containerRef?: React.RefObject<HTMLDivElement | null>;
}

export const Impact: React.FC<ImpactProps> = ({ impact, containerRef }) => {
  // const containerRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "start start"],
  });
  const scale = useTransform(scrollYProgress, [0, 1], [0.5, 1]);
  const yOffset = useTransform(scrollYProgress, [0, 0.8], [300, 0]);

  return (
    <div
      ref={containerRef}
      className="mt-12 w-full flex relative flex-col justify-between items-center gap-8"
    >
      <p className="lg:text-2xl md:text-lg text-base w-full font-gilroy-bold ">
        {" "}
        Impact
      </p>

      <div className="relative lg:w-full w-screen h-full flex justify-center">
        <motion.video
          style={{
            scale: window.innerWidth > 1024 ? scale : 1,
            y: window.innerWidth > 1024 ? yOffset : 0,
          }}
          className="w-full object-cover rounded-[10px]"
          src={impact?.video}
          autoPlay
          muted
          loop
        ></motion.video>

        <div
          style={{ backgroundColor: impact?.bgColor }}
          className={`absolute top-1/2 lg:h-[220%] h-[220vh] w-screen -z-10`}
        />
      </div>

      <div className=" w-full flex lg:flex-row flex-col lg:gap-0 gap-8 justify-between lg:text-2xl md:text-xl text-lg font-gilroy-regular lg:py-8">
        <p className="  lg:w-3/12">{impact?.text} </p>

        <div className="flex lg:w-1/2 lg:flex-row flex-col lg:items-start items-end gap-8">
          {impact?.stats.map((stat, index) => (
            <div
              key={index}
              className=" flex flex-col items-end gap-2 lg:w-full w-fit"
            >
              <p className=" w-full lg:h-[10vh] text-base lg:text-start text-end">
                {" "}
                {stat.metric}{" "}
              </p>
              <div className=" flex flex-col text-nowrap h-full lg:w-full lg:text-[28px] text-2xl font-gilroy-regular lg:text-start text-end text-primary">
                {stringToParagraphs(stat.stats)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
